// Types
import { ShortCaseResponse } from 'app/modules/cases/responses';
import { FullTagResponse } from 'app/modules/tags/responses';
import { U21SelectOptionProps } from 'app/shared/u21-ui/components';
import { InvestigationsAgentStatsResponse } from 'app/modules/investigations/types';
import { GoogleDriveDoc } from 'app/modules/uploads/models';
import { Filter } from 'app/modules/filters/models';

// Used in sliceCases
export interface NewCasesState {
  adminCaseFilters: Filter[];
  myCaseFilters: Filter[];
  queuedCaseFilters: Filter[];
  cases: ShortCaseResponse[];
  agentStats: InvestigationsAgentStatsResponse;
  loadingRetrieveAgentStats: boolean;
  loadingRetrieveCases: boolean;
  count: number;
  loadingCreateCase: boolean;
  loadingEditCase: boolean;
}

export interface CasesAddAlertParams {
  events: U21SelectOptionProps[];
  entities: U21SelectOptionProps[];
  action_events: U21SelectOptionProps[];
  instruments: U21SelectOptionProps[];
}

export interface CreateCaseLocationState {
  originating_alert_id?: number;
  alerts?: {
    id: number;
    title: string;
    description: string;
    tags?: FullTagResponse[];
  }[];
  assignee?: number;

  // separate out entities + events into separate fields instead of using alerts
  // because there are different formats for the alert entities + events so
  // the caller should be the one that deals with the formats
  entities?: (number | string)[];
  events?: string[];
  actionEvents?: string[];
  queue?: number;
  instruments?: (number | string)[];
}

export enum CasePages {
  ADMIN_CASES = 'ADMIN_CASES',
  MY_CASES = 'MY_CASES',
  QUEUED_CASES = 'QUEUED_CASES',
  QUEUE_DETAILS = 'QUEUE_DETAILS',
  QUALITY_CYCLE_CASES = 'QUALITY_CYCLE_CASES',
  REPORT_DASHBOARDS = 'REPORT_DASHBOARDS',
}

export interface CreateCaseFormValues {
  title: string;
  description: string;
  assignee?: number;
  queue: number;
  start_date: string;
  end_date?: string;
  tags?: number[];
  watchers?: number[];
  alerts?: number[];
  entities?: (number | string)[];
  events?: string[];
  action_events?: string[];
  instruments?: (number | string)[];
  add_related_entities?: boolean;
  add_related_txn_events?: boolean;
  add_related_instruments?: boolean;
  s3Docs?: File[];
  gdriveDocs?: File[];
  gdrivePickedDocs?: GoogleDriveDoc[];
}

export interface CaseDetailsFormValues {
  tags?: number[];
  watchers?: number[];
  alerts?: number[];
  entities?: string[];
  events?: number[];
  action_events?: number[];
  instruments?: string[];
}

export enum CaseDetailsPages {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export type CaseStatus = 'OPEN' | 'CLOSED' | 'IN_REVIEW';
